import { list } from './classes/request-builder';
import type { DropdownData } from '@fitogest/reactive-form-builder/interfaces';

import type { ClienteModel } from '../models/cliente.model';
import type { ParcelasModel } from '../models/form-common/parcelas.model';
import type { SectorModel } from '../models/form-common/sector.model';
import type { ProductosModel } from '../models/productos/productos.model';
import type { VisitasVariedadMesModel } from '../models/visitas_variedad_mes/visitas_variedad_mes.model';

export class DropdownLists {
    /*******************
     * Farm Properties *
     *******************/
    public sectores: DropdownData<SectorModel> = list<SectorModel>();

    public parcelas: DropdownData<ParcelasModel> = list<ParcelasModel>();

    public variedades: DropdownData<VisitasVariedadMesModel> = list<VisitasVariedadMesModel>();
    /***************************************************************************** */

    /***************
     * Farm Actors *
     ***************/
    public clientes: DropdownData<ClienteModel> = list<ClienteModel>();
    /***************************************************************************** */

    /******************
     * Farm Resources *
     ******************/
    public productos: DropdownData<ProductosModel> = list<ProductosModel>();
    /***************************************************************************** */

    /***********************
     * Farm Categorization *
     ***********************/
    public propiedad: DropdownData<string> = list<string>(['...', null], ['Propias', 'Propias'], ['Arrendadas', 'Arrendadas']);

    public tipos: DropdownData<string> = list<string>(
        ['...', null],
        ['Agricultura Ecológica', 'AE'],
        ['Producción Integrada', 'PI'],
        ['Certificacion Privada', 'CP'],
        ['Agrupacion de Tratamiento Integrado en Agricultura', 'Atrias'],
        ['Asistida de un asesor', 'AS'],
        ['Sin obligacion de aplicar la GIP', 'NO'],
    );
    /***************************************************************************** */

    /******************
     * Auxiliar Lists *
     ******************/
    public year: DropdownData<string> = list<string>();
    /***************************************************************************** */
}
